import React, { useEffect, useState } from "react";
import { Modal, Button, Checkbox } from "antd";
import { useLocation } from "react-router-dom";
import JsxParser from "react-jsx-parser";
import dayjs from "dayjs";
import { render } from "react-dom";
import { ndaHandle } from "./state/actions";
import { useDispatch, useSelector } from "react-redux";
import { Layout } from "antd";
import { ModalChild } from "./components/ModalChild";
import { NDAFailed } from "./components/NDAFailed";
import { NDASuccessForm } from "./components/NDASuccessForm";
import { Loading } from "../Common/components/Loading";
import html2PDF from "jspdf-html2canvas";
import { NotAutharised } from "../Common/components/NotAutharised";
import "./styles/ndaForm.css";
import NDAHeader from "./components/NDAHeader";
const { Content } = Layout;

function NDA(props) {
  const dispatch = useDispatch();
  const [lodingState, setlodingState] = useState(false);
  useEffect(() => {
    dispatch(ndaHandle.getNDA_JSX());
  }, [dispatch]);

  const { ndaData, getNDA_jsx, getNDA_jsx_validation, ndaErrorData } = useSelector((state) => state.nda);
  let { search } = useLocation();
  let queryParams = new URLSearchParams(search);
  let userId = search && queryParams.get("NDAId");
  useEffect(() => {
    setTimeout(() => {
      let persistData = {};
      if (search) {
        let accessToken = queryParams.get("accessToken");
        persistData = {
          disclosingParty: "HANA SOFTWARE, INC",
          disclosingPartyDate: dayjs().format("DD/MM/YYYY"),
          disclosingPartyTitle: "CEO",
          receivingPartyTitle: queryParams.get("receivingPartyTitle"),
          nameofCompanyReceivingParty: queryParams.get("nameofCompanyReceivingParty"),
          nameofCompanydisclosingParty: "HANA SOFTWARE, INC",
          nameofPersonReceivingParty: queryParams.get("nameofPersonReceivingParty"),
          nameofPersondisclosingParty: "Si Hyung Park",
          nda1Signature: {
            sign: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASYAAABVCAYAAADkBUkBAAAAAXNSR0IArs4c6QAAG6ZJREFUeF7t3QOwLMuyBuC8z7Zt27Zt27Zt27Zt27b97rNtxneiMyJvnZ5pTPec2b0rI1bstdc0qrKqEn9i7hedOgc6BzoHbowD97ux8fThdA50DnQORBdMfRN0DnQO3BwHumC6uSXpA+oc6Bzogqnvgc6BzoGb40AXTDe3JH1AnQOdA10w9T3QOdA5cHMc6ILp5pakD6hzoHOgC6a+BzoHOgdujgNdMN3ckvQBdQ50DnTB1PdA50DnwM1xoAumm1uSPqDOgc6BLpj6Hugc6By4OQ50wXRzS9IH1DnQOdAFU98DnQOdAzfHgS6Ybm5J+oA6BzoHumDqe6BzoHPg5jjQBdPNLUkfUOdA50AXTH0PdA50DtwcB44gmB44Ih5x+PnfiPjbiPjHiPifm+N2H1DnQOfALA7caYLpYSPi2SPieSLihSLiGSLC38bolyLiqyLiayPiN2Zx41gXPVhEvGNEPHdE/HpEvG9E/OexpnhXzeaxI+KtI+KVI+ITI+LTjjz7O0UwPUZEvHtEvEOzGH8ZEd8VEb8XEX8eEQ8REU8fEc8ZEU9Wrn3TiPicIy9kM7eHiojvjYjnKH9/xYj4hhU88Kx/jwjWaKd1HGDVP0lEPG75ecyIeJhBseKxvfvPw8+/RMRfRMRvD3v7mSPio4dXf3hEvH9E/Ne6odwZd926YLJw7zZo++QoYWSRCKRfOXNgHj0ivmywrNxrMT/ozliWi0ZpTb8yIl51mP/LDpufkPrJmU9+lIh414h4rYh4+EHY//7Me/tlEQ857Ds8f66yBy/lDQX8fBHxJ5c+6Nbvv2XBZHG/pVnUTx4EzN/NZOyDRsQnRMRbRcQ/RYQDdyR3huBOfO2Rht+5bu888MecubrvGREfMZNnrNMfjYgnGnjGXXYgOp3ngP36whHxahHxuiOX/kRE/FhE/G5EEPJ/EBH28b8OP/8dcc+Xgzx4RDzcYFn9zIlXgic+IyK+76iW7K0KpgcZ8CHuB4IXvVFE/OyK0+HwOqAILvX9K55xX93CxH/qAUt7xoh4vIh4tIjgBjzOxKAIFz+fEhF/NHMC9sO3R8SLD9e/TER868x779bLrNHbRMT7NHgny57FTnj8yCCElvDo0yPiLYYbrOMLDHvh1QdF46Pfiog3HATekmff/LW3Kpg+rDCfUHmKiPjTC7jJ7XvRiHj5iPimC55zjVtZKkDOF4mIp2teiBe0bdW6sDV4hIPwJoO19CoD6L90vIT/5w43fcGw6Zc+4265Hm70mhHxsYOyyHn/dER8XER83QXW+dtGxCcVRlJOv1b+z/L/yEFZ+/MSi/iOWJ9bFEwwjb8v3OOG0R5rSXTqrwdt9ggR8Q9rH7TzfUD7d4mI12ne892D1fI9w+b8vxPjeOiI+LNhfk8YEVyDJfRYBbsgAJ84Iv5qyQPuomsfdViTZy1z/ubBXeauXULP1HgGp7DRB4qIz4qINx5eJgILtjgE3aJget6I+KHCXekBP7WS2ywOgDdLiXb7ipXP2fM27hm84CWbl4hAsl5EauYQK4vb5j7h5KUk/PyWw03+NaZO9+YALA8cUK1ZrtynbsAs2NLPD/iex3HVKCxR0TFitX1jRLz08KEx/fIG45jzCGMlmOFkvxoR/zHnprnX3KJgeqXGDVkT6gd6E26iIvCpt4uIH5zLlCteJwz8bY0r8J2DgFgSBTNfADXciTZnIS4h1tHvDDc4DE9z9HD0EuaUa1ncYIG0lLjPcNBLraR8xRc1wLl8PfjSOaJwYVno84oFtXKKs24T8ZUjmPRyEcFi3IxuUTA5XBWstTDPvzCT27yEyT2HBrpFgiX9QgOYMss/PyJOuWun5sH9++KI+JITEaGp+cOTXn+4iGL4+qkb7tLP4ZP2Ffq54fdLsM/KxteLiC8sf2CxpgV7jt3c9oya+peS2ZOkP1RhKZ0nc6w2e+8tCiaT+8XGVJYm8E4rcJPNGLXxg+BePx4R8ISkD4yID1jxHmson+upVkYdJf5J5EOsS9G/nkx574XgJtmXSU9arMwVy/YAtzx5U52wBOMzDlZu0p5nWioDEJ5SRaADQP3mtOckLhmstPuvaR7wAxHBrUuX45Ln39f3CvlWvOuHB6GyFLA2jxeLCO7fH0fE468QKh9fMurxXTSp07058H4RQXkgVQgftRGT4EQw1Kqk5KGJ7M2hCn0QUITcXsQ6Eg1E3kWJycPanG5VMJkoC0kotiURug/dMPs1ebDUfbpkMeBfQH5EO7J2CJYxkicDWDxVlPwdQ96Rg/PBCwcFyP2b4R5ugDKeXvw8zsTq7lIA91/I61OXpxuen9sHrKBTgHf7nLqXuPNcwj1IOU2dM0G6G0xyy4IJc1kDBFGajpXhQqNyPZaAxO2C0TYiWFwrIKJkuL1JhnDVMu8VEeqfTpFoGeGhCLel6l7g0VJeKDtJzU8RsJ46jXMgFQB3V6RsigQ1RIRlfJ8iSseaSZpNkjn+1VMPHz6XMKwmMkmN6Ln3zXzs6GVfOpQo+XD3vKn7QjBZVCHGuRqHXytx0OEd6yQgIvExK6S3TSE5MZ+5p7apK10xHX/3fwmTp+jth0S6scPwmRHxZhEh14kQX0Ky6x2KzCB3OHre0mkOZsTMwScAzpGMeVEqa0aQnaL3aJQSUJklPcd6F30FwOf6EWaE2hxipcmDcnbmwAeix1kew4V72guSR+eM757anGsRt0GkQahxTaU7QYLxtDzXpyWYDXcmgdypeRFI+jYlqW8S1dqbalSDGycf5BypcVN2oCi50iOXtIA1OVrypmh1ZIO+9t4Tv8OfX/EVVu8pV0uXACA5t9ie/bcT87aeFGOluRYPC1/CbcIBss2VrMzBe2oCJwHFEpqirJxw3VXKuq4lmIT75T3Qypcm7xmz53E9MnRbGcu9Y2rOWSQLoy5MwhyL6RqtJJ6ylBfMcQskr/1hRLxUs3sSgyPcFN7OmW99RA1929S3mOc1dWCu+XkVJNxfAHhLlIVUCwJjCvOTkKmqIUmqwBvMmJBcKko46xlhUvKqWiF36lEVxP/sweI+91qFyYTgVRXYNQQT5J7JibZuPcJyeu/i+yaDhTThR785Y6GvfYnSkczmlqDXWkJ1PBIdZfJmFMi9BBQrS2pBmvGsPRrcj+4J/iWwlPb4UYZTUwAUAWf+DdCbO4n8nZt9Sstfm1e39r4XHDKtWduiZvaztVQoThgJn8P6CC778pSbZN9SOEnWioU1JVzkKLFys9eY+yQR1zq6KZ4pKNaBAoFHYJyniLvHdc2EUs3qtsrbOjvOvQWTlhx8U4sFxK4aYoqBSz4n1dUNVZDcoScUxxipKNjmYnbTOEtB4yVjG7uWdZY1ccZySoDahFwuVhbhweU61bFzakw2MQyJoHKQaiM9lluWWLTRFuFnUSjk4FTMBP4Hf/A8gk9KR3sYz90PJ/FeIXNj2yrK40CxAglxe0JUk4D/8g3W2lpox5N7DeZSBYUk2Snw2v1ZRoKvUyUt+AxrzFC9e7xDGRK+KduiiI3Nnib0pH1IQ6lU4Qv7wZ5yTk4RyCXTR1oL0PytnVbWhN2muW97CyYdE9WpmbyasE3raRpuMqPlg1ThZGE01mqpujGXZss6VEtD7LJ1aSKuLZDUBmifkbVvWl/I6coyE0Kt9vsRrYN5wDNYVPnj/358RnD4HTbh/1W4Ecxa7wo7wxuqkH6N4TAn/6rF6/AD3WEOyBrr3aSQOKm9X9SPC4pof4Iox1KT9RwuFiFFxnrz3qzdMw/v5MrActrOpLQ6d6oW2AKVzZvQBTjXA37mXJ79yBo+y9CKRG8lOI8WzlN7gdVVo78EPeE+Zl2Zq71BKFTh9+bDusBt4aK1ztI6sOKcg9ZDyZw3E5MTCMJQNO8Hz7W8SbKvjY1155nWS2dNayoiXiOJoo/etRntKZhqMa6q+bGcpM0mMjyIxtClsR68sXojgHJiBGvbewCxbRgHRK3anOhGnW8dqw1BwNjYBLjePrpHwstoShE0wChNyHpJ13hN5m11485hXG0ou32X1irVMiAIamOz9v4Wz1B6k5gKQULjJ3GTVMsjY8Rr7imeiMDmoWi7crIcKJ38nNIB6mcIPS3VJxhwu63339TzxpIp2/3JTSeo1J+xvnIvs3DsVUJVB0uRMYo/FTHhoW0NK1tUT5qJhNkKFbgXiD9GbSCmKhWRX+kSLM50A+szWMoE7ma0p2BKa8lguXS1lclmExh5UI2e+JjmzYxd/3fILWxuXoxeWoSZh5KAcFjWYllMYXlU3I5K3ANa0YK3pG1uhoVp0blRyHwOt0GJDzqH+RGI2UbDpiUQs3MoHhKSqcUVSecz8z3t/SyZbNjXpkxouZKWVlv64R3eBxyuVlAbHmcZVwDf2nCXKm6jjxFrE/B8X3QyJSRr5Bc/WIX2IgvMHNoeXPYAmEIXgQxwEMhKmpLsFwGhnCvrxh7xfO9z9riD3D7AuRpNiq622FE98BLDA/Hbnib0PFsknXVsnM4SPrPkcx9SpJKeN6O9BFOt36nm+2YDP/MgGqj61m1+UjVnbV7aaQmlUGK620hzM3TPvQOITbOxvGwim2IslwUexe1C2qsay1Li7uYBN/e0vupzsrdTauu2UNPhlteT1Pa5au9vMRTuV/YRagHYqtBseG7SWBpHxea8j2WV1oPDzOJIQehaVhiXZyq3aCk/514/lkxZ72XxECzcUz8wMT/VNXY9t0ttZAY+WIWETGJFbSZ5WrK5b2VwZ5UB4ZZfWFFTTliyLFrEhSZQ8dffsyRMSx4WGiIIN22/vJdgYoZnrc+aHJu5iz12HesMIJfEpIXXJElboAGQivp6wKbeWw/clkWcU+/Nz+tmmJvzUp9dLRUbWZrBmACs5UCuo81TWztgBGcejDF3sr2f65SRvrZgtbZpqTk2NLW2vvYSQej9hDFq3W/uXfY5N15Wh66eyB5nEecBvK/aBbeWPAHC7aLYlkRB6x4wv6pcWDQERyoUJUrgBiRDnKB+heH/1TLFMwKLFQlrkp5SMSRuuDQf+BnlCafLL/bYJa9pL8FUm45d0uht7oGt12WIPf9WG6c5iKmB2vwfmshmOdfwK0s4lhRZrpnD2D017QKYyzJcSsbtECOuFxesJUEE7WKAxYhQr99hVvNgfN42JyNobOy8X/U54ZUEyId9IO0yKubBejNP5LDkt42wIFgJ6TpWpVDbAbuvzclqweZWURJUXNSpvkdLeV2vb13XU7yfekebZtCuDZcPqJ38Y8kAwlMIcW0zqbYmTdbcQmNj4SaxmKyhwAYhSOlYB4qDO5c99Ll/cFIu3cVu8l6CyWATN1nTuGxqgc593kaC6iaumvxDmvozgDiNfa60Q+kId+Ha4CkNCBdIV2Vt7/K6GU8196oRy1Z4m3eN2smf0Y+6EizEs1F7f4uNsLryq4hqaDqfR6hwyzJC6e/VNbd/Ze+LOqKxA9+G5mXRs7gQF5RQ2rMHlQNrDgkaE75+XwMB1IAB65HlnxZvVVzmxlXWOA45j4JRrCFBGmczBQoFkBZtu76ih4I7orXwJNeai2CF99eEZEqdAqPYLk5U3ksw+TaTbOMgrDyn9ucSYZT3mg98KTdBjfb4jJmbh7tWiIuE0fIyyW3kMWLC0gRrcKlL51bznvj6eDsVlm7fyQUT7k0CBGdngfxbjdj5Wxtar26wz1vsiRKqeTG1PQj+A02zjKLNdIZ7AMiTBBVEgQgduWjpntQ8q7Zpv/FXsLuW3eRzazkURSXIQLiei6oC54H58CmKzrXGxEUUUZXHc4okWlKCiKA2/rWtewjh5ENNdmx5W9NzWDrSMgi1xISq4VADF7VTgfVgacE+E9c8FShyNkSUCcJNQPC9BFMFN0nQivlcekjP3V9707QJllVbtxEd4wUSnmuSRqCxmKayZbeeX+uqSDNY85XnNWp1Kk2AxeGg2mioRlPb9ACftx0NuBIA0rH7afCac1SxkbY/lbA2oYi4C/llFDS4ZFpE0LK2WD2ojb7CA/FJkIIQToGYgs2BE9GcSohkndZvMCZkBBCcHQeVoKqpDnX9W+vdGrRJj3P3S+1U2eKmLW8r1EAIUsL4RDG1X3aQa9xas9ltolqrp6LruUc3O+t7CSZ+rk2K5vQtnrs4567DNAcuQdlnGzZl3sP/TcCu4hBZVOvrkmoLifZdaf7u0kr0xMRocthK0iWFxjWSNpa71W7MuvlZlMYBn0ucp62yP3d/i7HUhmbC2J5r/RD3kNBKV6eWUFR8SKoDaySFIGyxlnnovOB6uIxQeBZ+p6XIgrBHWAWnrE9WSe2TtSTgIPReExbXut+59rXPdhXqLW9dn9YU7Mg6ViyvpovU3DLRz8zw9wyC0N9qu5OxHkysVMEQUIivXduE9hJMFaS7RoN0SWkKDTMMPnaA0z/P2jDuJS0iJEurntJ6yegUYKcKODdZkPIQGp1pnYJANEb7l7VUXYq2jS/hQKj7NzdnCm8YCUuFxaGuKjdf/Vot7gVB5docr+sJlcRYXCP4INpTLSKHo86rKhT7s5Y6pMZO648rZV24SNYyr02AnsUC86pRL8/MkDrr61wPLtZjZpxzY1l2UySJUhF5bdpXca2p+099zi12+M0VHwhTwQHj9zffm4gyMCIrnMDnrnNFk+oXHojQ4Q/3q9bMEcaidKjiWu1XRIFpQB+SPa37kujiWT7sJZi8NHsF+X1NEuPcBWSy00xpqp9qvJZZrzX/B4Yh3EkDneogmeNwYGkQIWyRnD0JCMl6SzyMFUHoLu0gUMdYoy01UmYPiESmds16Ri6K+RIc3DOpFazKLIchZITkWSx4SpBxuTLKRpPD7dwvCseiYqmZRyZ2tt+20VpyhFoCqZQHoZXWG6EHqE83zyF1LTfGWktX8bv35dd/Eb5ccetOwBLW56hGMecoBjxx8FNIeLasaTy4lNICyxIqUWQuJn6IfPs74Y+HXDtC29xhTPUrnWqCLgOCMoJBWWv7DtV1sOaSK5E1cM6UlilvUs3BAltiSc7iw56Cib8pgpNg3R5pA7QlYNgBpjXgICJPYyQzVkTBdUxbDLaB5ibcWYis9avRpFmMXnAR1yKzbPM2GygByAWPeoBLq8WUpS7W3+aiCaVCSLhLIFfggJlOoMAQ1PRlIzmKQIEsc19hsWsAzXg7dn8m+VEatLPr4Du1z7XB1uS/HDw3gTZ2D6sBlkTgUSj2mENnj8EUJae6tgodgrZNAYHzsJamokftdxyeaurHSiI4eAeZ/2M8rPCt0hBqAa79kXlZhDUsTbEtYB+fWC7GMdZvqUY/CRprw9oV1Eml1FYE1KRcvOOdcE2t3yXwwsm9vKdg8lKCQ40NpmIYrTqWabz0sHHdMC8LQgkc2annWjLQvjZsfk0RzEQN35KK9jRrRZQc1i0rqo1P5CfzjJInc5t5TfGQ2V6/lolWFEWT25Jhdqa5KA1XxMa2YfGZsK8YHauDOwGYpqkpBHys94tg0ugwjhSq3FPZ3LRs4i9ZgOpZrOyW7CHjSyFWq+pdy5KFgxDo3idLvCqn9rvauFgA7Lm5NhVjsYe5iQ4qJQXL8V4uX2KbxmS8BHAmeU6tzdzP7VcKxNqwUlm+mZcnu53AMg7rJngw1mOLhaQaI3PJ5PmxovAu+5u11qSAi9KpagkSuBRN/XLaufOYvG5vwWQAbQ8ZPjtgfIlA8BwHl5Z0UNOdoJUcZIxeWkQ7yZyRC2q5i3mIWGwhnCw8c78tkNRYnkW4BdmQlERbl8ftISzO8a8tMcnxqKVjwaz92nVuCPdULtFU+gPllnlLc/hBYEg5qA3dMi9qzv15DVeVe+o551rOgALgUATxuVbJS949di3rDB/G1otiIPzbMpax53hGi+FNjY1ygOVJyVjSA2rquff6/BqCyUstKI1I6+bikuo0JDNU2Ndk07TmNvHXgXY0AB9WpC/vFWWBLchinTLHFzNl4oaaCmEMtP9a4SQ9gWYb69XMVapRnS3mwcoh7LwX3/HxlIIQjsd3LjCzPYtLKQOuMMwli3q3GNsWz+AKst5gYm0xrOJVUbq1REDhB7daZI/FxGViFXE3uZTXytdbO4c75r5rCaZkCM3LlZIZnK1BK7MyOa/W6eTnPiMU+PF7aqSpxcsIVIafhb5hNrCWOQcVbmPuIkZjPOAaif7UFiJTY9rqc+4AIQQvaS0r77AGMJy1FtJW46zPkc2Ml/ZVjpmbwaWDnWWUcNevG9pjYnfzM68tmCqvs/shN4YGAmTCPIzJxnfINUdjMsKDznXau/YasjyAwa3rxYpQOsKsV2+mTsmcYBGiXARybd3RjlskiVV5SfRtKS/kSsGfuD0pbPGaNQrkZBEm0EoAwCNugUThhOFhYBSZMavJI5AEXepXG10jknoLPDnMGO5LwXSnM5GmpqXhMxX4XDMv0RHafasIzpwxiKiJViX47GAD94GqrDVuSc1cXvMVUXPGseYagQcAPIGEZ1xLwidxF24o1yrTLfaICK8Zd79nJge6YJrJqDOXwR4cYAKq9tGe82QWlkBA5tnMuWeLa2rpjgQ7SaMwv4qVtUWh53qTbzGmOc+gDAhTgokLLc9orLaxtkHZvInZnIH2ay7jQBdMl/Gv3i1qqAe0KKQfOS8Os0Q4GpxFom5J618WEtA5vy1lu1FMP6m2hWEtidS1JNHOOBPry4La6afvd4ViXlnOXGE4oxD9WGSqWnnAfekQUxG//Ubdn7yKA10wrWLbHXuTUDPMjmV3qoZRZEvWcLqn1+5Aeoq52aedq0n4jAklLlv2924bxt2xi3Y3DrwLprtr1RMQPtUhQbIiq6S2qNWf6topGWOrIphAWIrsjgUH2pbK1yoev7t20JVm2wXTlRh9I6/JFhZjpR+yfmU5Z66YqCNwf04KxN7Ty0TAsa4IWZSbLZKlW3Df1rSG2Xse/fkzOdAF00xGHeSyxF9Ug2c7FZm8UhSyvMdU1dVxndYmju7BLukLSo5qJwLJnzLPM39JQqrSpFsQpnvw4K55ZhdMd81S3zNR1pBUAEmeas5EuQDbSfKv5Abld9XfEnfUdukXztW8/1CHWb8EUsoAF/UapUm3xJdDjqULpkMu69lJiRA65Fw3xdD69ajWd+C1XL3lCBYMTKEzgUQAqQDwRQUA8do2+O5b1YPNuAumgy1on07nwBE40AXTEVaxz6Fz4GAc6ILpYAvap9M5cAQOdMF0hFXsc+gcOBgHumA62IL26XQOHIEDXTAdYRX7HDoHDsaBLpgOtqB9Op0DR+BAF0xHWMU+h86Bg3GgC6aDLWifTufAETjQBdMRVrHPoXPgYBzogulgC9qn0zlwBA50wXSEVexz6Bw4GAe6YDrYgvbpdA4cgQNdMB1hFfscOgcOxoEumA62oH06nQNH4EAXTEdYxT6HzoGDcaALpoMtaJ9O58ARONAF0xFWsc+hc+BgHOiC6WAL2qfTOXAEDvw/Dm6xoZnsceUAAAAASUVORK5CYII=",
            timeStamp: dayjs().unix() + "",
            id: "nda1Signature",
          },
          nda2Signature: JSON.parse(queryParams.get("nda2Signature")),
          receivingParty: queryParams.get("receivingParty"),
          receivingPartyDate: queryParams.get("receivingPartyDate"),
          // receivingPartyEmail: queryParams.get("receivingPartyEmail") || "",
          id: queryParams.get("id"),
          sendMail: true,
        };

        let getDate = (date) => {
          return dayjs(date).format("YYYY-MM-DD");
        };

        // Astrics infront of receivingParty
        let recivingPartyElement = document.getElementsByName("receivingParty");
        if (recivingPartyElement) {
          let divElement = document.createElement("div");
          divElement.innerHTML = "*";
          divElement.style.left = "530.3px";
          divElement.style.top = "758.2px";
          divElement.style.color = "red";
          divElement.setAttribute("class", "control");
          recivingPartyElement?.[0]?.parentElement.appendChild(divElement);
        }
        // Astrics infront of nameofCompanyReceivingParty
        let nameofCompanyElement = document.getElementsByName("nameofCompanyReceivingParty");
        if (nameofCompanyElement) {
          let divElementnameofCompany = document.createElement("div");
          divElementnameofCompany.innerHTML = "*";
          divElementnameofCompany.style.left = "530.3px";
          divElementnameofCompany.style.top = "797.2px";
          divElementnameofCompany.style.color = "red";
          divElementnameofCompany.setAttribute("class", "control");
          nameofCompanyElement?.[0]?.parentElement?.appendChild(divElementnameofCompany);
        }

        // Astrics infront of divElementSignature
        let nda2SignatureElement = document.getElementById("nda2Signature");
        if (nda2SignatureElement) {
          let divElementSignature = document.createElement("span");
          divElementSignature.innerHTML = "*";
          divElementSignature.style.left = "-10.3px";
          divElementSignature.style.top = "0";
          divElementSignature.style.color = "red";
          divElementSignature.setAttribute("class", "control");
          nda2SignatureElement?.parentElement?.appendChild(divElementSignature);
        }

        // Astrics is required
        let astricsElement = document.getElementsByClassName("page");
        if (astricsElement) {
          let divElementAstrics = document.createElement("span");
          divElementAstrics.innerHTML = "* Required Field";
          divElementAstrics.style.left = "750.3px";
          divElementAstrics.style.top = "203px";
          divElementAstrics.style.color = "red";
          divElementAstrics.setAttribute("class", "control");
          astricsElement?.[0]?.appendChild(divElementAstrics);
        }

        let getAllInput = document.querySelectorAll("input");
        getAllInput &&
          getAllInput.forEach((ele, index) => {
            if (ele.type !== "button") {
              ele.value = ele.type === "date" ? (persistData[ele.name.trim()] !== undefined ? getDate(persistData[ele.name]) : "") : persistData[ele.name.trim()] !== undefined ? persistData[ele.name.trim()] : "";
            }
          });

        let getSignatureComponent = (id, getSIgn) => {
          let appendDiveElement = document.getElementById(id);
          let parentDive = document.createElement("div");
          parentDive.className = "signatureDivAlighnment";
          parentDive.style.cursor = "default";
          let imageDiv = document.createElement("div");
          let imageElement = document.createElement("img");
          imageElement.setAttribute("src", getSIgn.sign.split(" ").join("+"));
          // imageElement.setAttribute("id", `${event.target.id}`);
          imageElement.className = "signaturealighnment";
          imageElement.style.maxWidth = "133px";
          imageElement.style.height = "72px";
          imageDiv.style.background = "inherit";
          imageDiv.appendChild(imageElement);
          let verifiedDiv = document.createElement("div");
          verifiedDiv.className = "signatureResureAlighnment";
          let verifiedTitle = document.createElement("div");
          verifiedTitle.textContent = "Resure verified.";
          verifiedTitle.style.color = "darkblue";
          let verifiedTimeStamp = document.createElement("div");
          verifiedTimeStamp.textContent = getSIgn.timeStamp;
          verifiedDiv.appendChild(verifiedTimeStamp);
          verifiedDiv.appendChild(verifiedTitle);
          parentDive.appendChild(imageDiv);
          parentDive.appendChild(verifiedDiv);
          verifiedDiv.appendChild(verifiedTitle);
          verifiedDiv.appendChild(verifiedTimeStamp);
          parentDive.appendChild(imageDiv);
          parentDive.appendChild(verifiedDiv);
          parentDive.style.top = appendDiveElement.style.top;
          parentDive.style.left = appendDiveElement.style.left;
          appendDiveElement.parentNode.append(parentDive);
        };

        let nda1Signature = persistData["nda1Signature"];
        let nda2Signature = persistData["nda2Signature"];

        let signatureArray = [nda1Signature, nda2Signature];
        signatureArray &&
          signatureArray.forEach((ele) => {
            if (ele !== undefined && ele !== null) {
              getSignatureComponent(ele.id, ele);
            }
          });

        localStorage.setItem("NDA", JSON.stringify(persistData));
        localStorage.setItem("NDA_accessToken", accessToken);
      }
    }, 2000);
    return () => {
      localStorage.removeItem("NDA");
    };
  }, [search]);

  // useEffect(() => {
  //   if (props.networkConnection === false) {
  //     window.location.reload();
  //   }
  // }, [props]);

  let changeEvent = (e) => {
    let localData = JSON.parse(localStorage.getItem("NDA")) || {};
    localData[e.target.name] = e.target.value;
    localStorage.setItem("NDA", JSON.stringify(localData));
  };

  useEffect(() => {
    setTimeout(() => {
      let localData = JSON.parse(localStorage.getItem("NDA")) || {};
      let getAllInput = document.querySelectorAll("input");
      let dateElement = document.querySelectorAll('input[type="date"]');
      dateElement &&
        dateElement.forEach((ele, index) => {
          ele.disabled = true;
        });

      let dateFirst = document.getElementsByName("disclosingPartyDate");
      dateFirst &&
        dateFirst.forEach((ele, index) => {
          ele.value = new Date().toLocaleDateString("en-CA");
          localData[ele.name] = new Date().toLocaleDateString("en-CA");
        });
      getAllInput &&
        getAllInput.forEach((ele, index) => {
          ele.addEventListener(
            "change",
            (e) => {
              changeEvent(e);
            },
            false
          );
        });
      localStorage.setItem("NDA", JSON.stringify(localData));
    }, 2000);
  }, []);

  let subMitComponent = (event) => {
    let handleCancel = () => {
      let getModal = document.getElementsByClassName("ant-modal-root")[0];
      let getbody = document.querySelector("body");
      getModal.parentNode.remove(); // .removeChild(getModal);
      getbody.style.overflow = "auto";
      event.target.innerText = "Signature";
    };

    let saveNDA = () => {
      let getFilledData = JSON.parse(localStorage.getItem("NDA"));
      if (getFilledData["id"] === null) {
        handlePDF(getFilledData);
      } else {
        dispatch(ndaHandle.editNDA(getFilledData, getFilledData["id"]));
      }
      localStorage.removeItem("NDA");
      // localStorage.removeItem("NDA_accessToken");
      handleCancel();
    };

    let handleChangecheckbox = () => {
      let localData = JSON.parse(localStorage.getItem("NDA"));
      if (localData["sendMail"] === true || localData["sendMail"] === "true") {
        localData["sendMail"] = false;
        localStorage.setItem("NDA", JSON.stringify(localData));
      } else {
        localData["sendMail"] = true;
        localStorage.setItem("NDA", JSON.stringify(localData));
      }
    };

    let handleOk = () => {};
    let localData = JSON.parse(localStorage.getItem("NDA")) || {};

    render(
      <Modal
        style={{
          borderRadius: "7px",
          backgroundColor: "#ffffff",
          border: "1px solid black",
          padding: 0,
        }}
        width="550px"
        id="changeModal11"
        visible={true}
        onOk={handleOk}
        mask={true}
        closable={true}
        okText={"Submit"}
        onCancel={handleCancel}
        footer={false}
      >
        <>
          {localData["receivingParty"] && localData["nameofCompanyReceivingParty"] && localData["nda2Signature"] ? (
            <>
              <div style={{ paddingBottom: "1rem" }}>
                {/* Resure always Recommends to validate before submiting the form. */}
                <Checkbox onChange={handleChangecheckbox} defaultChecked={true}>
                  Send a copy of NDA to your Email?
                </Checkbox>
              </div>
              {/* {getNDA_jsx_validation.length > 0 ? (
                <Button onClick={handleValidate}>Validate</Button>
              ) : (
                <div></div>
              )} */}
              <Button onClick={saveNDA}>Submit</Button>
            </>
          ) : (
            <>
              <ul>{!localData["receivingParty"] ? <li>Name of Receiving Party is Required</li> : !localData["nameofCompanyReceivingParty"] ? <li>Name of Company is Required</li> : !localData["nda2Signature"] && <li>Signature is Required</li>}</ul>
            </>
          )}
        </>
      </Modal>,
      event.target
    );
  };

  // Save button and Click Event
  useEffect(() => {
    setTimeout(() => {
      if (getNDA_jsx_validation && getNDA_jsx_validation.length > 0) {
        let submitBTN = document.getElementsByName("typeSubmit");
        submitBTN[0] && submitBTN[0].addEventListener("click", subMitComponent);
      }
    }, 3000);
  }, [getNDA_jsx_validation]);

  let updateSignatureEvent = (event) => {
    let handleCancel = () => {
      let getModal = document.getElementsByClassName("ant-modal-root")[0];
      let getbody = document.querySelector("body");
      getModal.parentNode.remove(); // .removeChild(getModal);
      getbody.style.overflow = "auto";
      event.target.innerText = "Signature";
    };

    let handleOk = () => {};

    let saveFunc = (signCanvas, destination, initial) => {
      let signFlag = destination === "text" ? false : signCanvas.current.isEmpty();
      let canvasImage = destination === "text" ? signCanvas : signCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      // Store sign in local storage
      let localstroredData = JSON.parse(localStorage.getItem("NDA")) || {};
      let timeStamp = new Date().getTime();
      localstroredData[event.target.id] = {
        sign: canvasImage,
        timeStamp: initial !== undefined ? timeStamp + initial : timeStamp + "",
        id: event.target.id,
      };

      // auto update sign date
      let signDate = new Date().toLocaleDateString("en-CA");
      localstroredData["receivingPartyDate"] = signDate;
      const dateSignElements = document.getElementsByName("receivingPartyDate");
      dateSignElements &&
        dateSignElements.length &&
        dateSignElements.forEach((ele) => {
          ele.value = signDate;
        });

      localStorage.setItem("NDA", JSON.stringify(localstroredData));

      let oldElement = document.getElementById(`${event.target.name}`);
      if (oldElement !== null) {
        oldElement.parentNode.remove();
      }
      let parentDive = document.createElement("div");
      parentDive.className = "signatureDivAlighnment";
      parentDive.style.cursor = "default";
      let appendDiveElement = document.getElementById(event.target.id);
      if (appendDiveElement) {
        appendDiveElement.removeEventListener("click", updateSignatureEvent, false);
        appendDiveElement.style.pointerEvents = "none";
        let imageDiv = document.createElement("div");
        let imageElement = document.createElement("img");
        imageElement.setAttribute("src", canvasImage);

        imageElement.setAttribute("id", `${event.target.id}`);
        imageElement.className = "signaturealighnment";
        imageElement.style.maxWidth = "133px";
        // imageElement.style.height = "auto";
        imageDiv.style.background = "inherit";
        imageDiv.appendChild(imageElement);
        let verifiedDiv = document.createElement("div");
        verifiedDiv.className = "signatureResureAlighnment";
        let verifiedTitle = document.createElement("div");
        verifiedTitle.textContent = `${signFlag ? "Not verified." : "Resure verified."}`;
        verifiedTitle.style.color = `${signFlag ? "red" : "darkblue"}`;
        let verifiedTimeStamp = document.createElement("div");
        verifiedTimeStamp.textContent = `${signFlag ? "" : initial !== undefined ? timeStamp + initial : timeStamp}`;
        verifiedDiv.appendChild(verifiedTitle);
        verifiedDiv.appendChild(verifiedTimeStamp);
        parentDive.appendChild(imageDiv);
        parentDive.appendChild(verifiedDiv);
        appendDiveElement.parentNode.append(parentDive);
      }

      handleCancel();
    };
    let handleCustome = (event) => {
      dispatch(ndaHandle.uploadImageFile(event));
    };

    render(
      <Modal
        style={{
          borderRadius: "7px",
          backgroundColor: "#ffffff",
          border: "1px solid black",
          padding: 0,
        }}
        width="550px"
        id="changeModal11"
        visible={true}
        onOk={handleOk}
        mask={true}
        closable={true}
        okText={"Submit"}
        onCancel={handleCancel}
        footer={false}
      >
        <ModalChild evnt={event} saveFunc={saveFunc} handleCustome={handleCustome} />
      </Modal>,
      event.target
    );
  };

  // Signature
  useEffect(() => {
    setTimeout(() => {
      let nda1Signature = document.getElementById("nda1Signature");
      let nda2Signature = document.getElementById("nda2Signature");
      if (nda1Signature && nda2Signature) {
        let ndaSignature = [nda1Signature, nda2Signature];
        ndaSignature.length > 0 &&
          ndaSignature.forEach((ele, index) => {
            ele.style.backgroundColor = "cyan";
            ele.style.color = "rgb(41 13 13)";
            ele.addEventListener(
              "click",
              (e) => {
                updateSignatureEvent(e);
              },
              false
            );
          });
      }
    }, 2000);
  }, []);



  if (ndaErrorData) return <NDAFailed msg={"Submission Failed"} subTitle={ndaErrorData} />;
  if (ndaData)
    return (
      <NDASuccessForm
        title="Thank you!"
        // subTitle="Please verify this NDA by checking your email (if not found, please check spam)"
      />
    );

  if (queryParams.get("accessToken") === undefined || queryParams.get("accessToken") === null) {
    return <NotAutharised flag={false} />;
  }
  // Here first converting the into pdf file and then uploading on the aws
  let handlePDF = async (getFilledData) => {
    let pdfParse = document.getElementsByClassName("page");
    pdfParse[1].querySelector('input[name="typeSubmit"]').style.visibility = "hidden";
    const pdf = await html2PDF(pdfParse, {
      jsPDF: {
        format: "a4",
      },
      html2canvas: {
        scrollX: 0,
        scrollY: -window.scrollY,
      },
      margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
      watermark({ pdf, pageNumber, totalPageNumber }) {
        pdf.setTextColor("#ddd");
        pdf.text(50, pdf.internal.pageSize.height - 30, `Resure, page: ${pageNumber}/${totalPageNumber}`);
      },
      success: function (pdf) {
        // pdf.save(this.output);
        setlodingState(true);
        let fileEncode = pdf.output("datauristring");
        let fileSplit = fileEncode.split(";");
        fileSplit.splice(1, 1);
        let fileBase64 = fileSplit.join(";");
        dispatch(ndaHandle.uploadpdfFile(fileBase64, getFilledData, userId));
      },
      imageQuality: 1,
      imageType: "image/jpeg",
      output: "jspdf-generate.pdf",
    });
  };

  return (
    <>
      {getNDA_jsx && getNDA_jsx !== null ? (
        <Layout
          id="NDAFormContainer"
          style={{
            background: "#F0F2F5",
            height: "100%",
          }}
        >
         <NDAHeader/>
          <Content>
            {lodingState ? (
              <Loading />
            ) : (
              <div id="pdfParse" style={{ width: "100%" }}>
                <JsxParser id="pdfParse" jsx={getNDA_jsx} />
              </div>
            )}
          </Content>
        </Layout>
      ) : (
        <Loading />
      )}
    </>
  );
}

export { NDA };
